/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React, { useState,useEffect } from 'react';
import axios from 'axios';
import toast from 'react-hot-toast';
import './index.css';
import StarOutlineIcon from '@mui/icons-material/StarOutline';
import { Link, useParams } from 'react-router-dom';
import Loader from '../Loader';
import Header from '../Header';
import righticon from '../../assests/checkmark.png';

function CustomerExperience({ baseURL }) {
  const { id } = useParams();

  const [experienceGetData,setExperienceGetData] = useState(null);
  const [gotData, setGotData] = useState(false);
  const [page, setPage] = useState(1);
  const [rateValue, setRateValue] = useState(0);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState('');
  const [number, setphoneNuumber] = useState('');
  const [morethenonebond, setmorethenonebond] = useState('');
  const [BailAmount, setBailAmount] = useState('');
  const [BondNumber, setBondNumber] = useState('');
  const [Location, setLocation] = useState('');
  const [Charges, setCharges] = useState('');
  const [CaseNumber, setCaseNumber] = useState('');
  const [whereheld, setwhereheld] = useState('');

  useEffect(() => {
    ExperinceApiHandler();
  },[]);

  const ExperinceApiHandler = async () => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseURL}/company/get-cx-review-links/${id}`,{
        headers: {
          'Cache-Control': 'no-cache',
          Pragma: 'no-cache',
          Expires: '0',         
        },
      });
      if (response.data.status === 'success') {
        setGotData(response?.data?.status);
        setExperienceGetData(response?.data?.data);
        setLoading(false);
      }
    } catch (error) {
      console.log(error,'error');
    }
  };

  if (loading) {
    return <Loader />;
  }
  const SendReview = async () => {
    const fromdata = {
      defendant_name: name,
      phonenumber: number,
      email: null,
      bail_amount: BailAmount,
      more_then_one_bond: morethenonebond,
      where_held: whereheld,
      total_bond: BondNumber,
      charges: Charges,
      court_city: Location,
      case: CaseNumber,
    };
    console.log(fromdata);
    // const res = await axios.post(`${baseURL}/testing/create-cx-contact/${id}`,fromdata);
    // if (res.data.status === 'success') {
    //   setPage(2);
    // } else {
    //   toast.error(res.data.message);
    // }
  };

  return (
    <div className="qs-page">
      <div className="qs-card min-h-[500px]">
        <Header 
          logo={experienceGetData?.company_logo}
          headerColor={experienceGetData?.display?.email_header_color}
          headerTextColor={experienceGetData?.display?.email_header_text_color}
          companyName={experienceGetData?.name}
          ratingValue={(experienceGetData?.rating_average === null ? null : Number(Math.round((experienceGetData?.rating_average) * 10) / 10))}
          reviewCount={experienceGetData?.review_count}
        />
        <div className="qs-card-body flex-1">
          {page === 1 && (
            <div className="qs-fade-in space-y-4">
              <div className="qs-title flex justify-center">
                <p>Sorry to hear that! Please tell us about your experience below.</p>
              </div>
              <div className="flex-col">
                <p className="qs-label flex">Defendant's Name:</p>
                <textarea
                  className="qs-input flex h-12 resize-none overflow-y-hidden"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className="flex-col">
                <p className="qs-label flex">Phone Number:</p>
                <textarea
                  className="qs-input flex h-12 resize-none overflow-y-hidden"
                  value={number}
                  onKeyPress={(e) => {
                    const validKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                    if (!validKeys.includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  maxLength={10}
                  onChange={(e) => setphoneNuumber(e.target.value)}
                />
              </div>
              <div className="flex-col">
                <p className="qs-label flex">Is More Than One Bond Needed?</p>
                <textarea
                  className="qs-input flex min-h-[80px] resize-y"
                  placeholder="Tell us about your experience"
                  value={morethenonebond}
                  onChange={(e) => setmorethenonebond(e.target.value)}
                />
              </div>
              <div className="flex-col">
                <p className="qs-label flex">How many?</p>
                <textarea
                  className="qs-input flex min-h-[80px] resize-y"
                  placeholder="Tell us about your experience"
                  onKeyPress={(e) => {
                    const validKeys = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'Backspace', 'Delete', 'ArrowLeft', 'ArrowRight', 'Tab'];
                    if (!validKeys.includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  value={BondNumber}
                  onChange={(e) => setBondNumber(e.target.value)}
                />
              </div>
              <div className="flex-col">
                <p className="qs-label flex">Where Held?</p>
                <textarea
                  className="qs-input flex min-h-[80px] resize-y"
                  placeholder="Tell us about your experience"
                  value={whereheld}
                  onChange={(e) => setwhereheld(e.target.value)}
                />
              </div>
              <div className="flex-col">
                <p className="qs-label flex">Charges:</p>
                <textarea
                  className="qs-input flex min-h-[80px] resize-y"
                  placeholder="Tell us about your experience"
                  value={Charges}
                  onChange={(e) => setCharges(e.target.value)}
                />
              </div>
              <div className="flex-col">
                <p className="qs-label flex">Court & City:</p>
                <textarea
                  className="qs-input flex min-h-[80px] resize-y"
                  placeholder="Tell us about your experience"
                  value={Location}
                  onChange={(e) => setLocation(e.target.value)}
                />
              </div>
              <div className="flex-col">
                <p className="qs-label flex">Case #:</p>
                <textarea
                  className="qs-input flex min-h-[80px] resize-y"
                  placeholder="Tell us about your experience"
                  value={CaseNumber}
                  onChange={(e) => setCaseNumber(e.target.value)}
                />
              </div>
              <div className="flex justify-center pt-2">
                <button
                  type="button"
                  disabled={BailAmount?.length < 1 || name?.length < 2 || number?.length < 10 || loading}
                  className="qs-btn qs-btn-primary sm:w-1/2"
                  onClick={SendReview}
                >
                  Submit
                </button>
              </div>
            </div>
          )}
          {page === 2 && (
            <div className="qs-fade-in flex min-h-[300px] flex-col justify-center space-y-4 py-6">        
              <div className="qs-success-icon">
                <img src={righticon} alt="tick mark" className="h-12 w-12 object-contain" />
              </div>
              <div className="qs-title flex justify-center pt-2">
                Thanks!
              </div>
              <div className="qs-subtitle">
                We will get back to you soon!            
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default CustomerExperience;
